export default __webpack_public_path__ + "static/card-d5f657ed1ac0a285b8dd6d413adbc5e6.svg";